import EventManager from "../../store/sqftEventManager";
import workspace from "../workspace";
import config from "../../store/sqftConfig";
import {getViewportSize} from "../../store/canvasHelper";

export default new function() {
  var self = this;
  const fontColor =  "#999999";

  this.init = function() {
    EventManager.addEvent(
      EventManager.events.RENDER,
      self.render,
      self,
      EventManager.priorities.OVERLAY - 1
    );
  };
  this.render = function(ctx) {
    const { canvasWidth, canvasHeight } = getViewportSize(workspace.getCanvas());
    let i, text, width, posText,
      scale = config.scale,
      gridSize = config.workspace.gridSize * scale,
      adjustedSize = (gridSize / 3),
      rulerSize = adjustedSize + 6,
      pos = workspace.getPosition(),
      start = {
        x: (pos.x % gridSize) * -1,
        y: (pos.y % gridSize) * -1
      };
    while(start.y < rulerSize || start.y < 0) {
      start.y += gridSize;
    }
    while(start.x < rulerSize || start.x < 0) {
      start.x += gridSize;
    }
    //render ruler
    ctx.clearRect(0, 0, canvasWidth, rulerSize);
    ctx.clearRect(0, 0, rulerSize, canvasHeight);
    //horizontal ruler
    ctx.font = adjustedSize.toString() + "px sans-serif";
    ctx.fillStyle = fontColor;
    for(i = start.x; i < canvasWidth; i+=gridSize) {
      text = getText(pos.x + i);
      width = ctx.measureText(text).width;
      posText = {
        x: i - (width / 2),
        y: adjustedSize,
        width: width,
        height: adjustedSize,
        text: text
      };
      ctx.fillText(posText.text, posText.x, posText.y);
    }
    //vertical ruler
    for(i = start.y; i < canvasHeight; i+=gridSize) {
      text = Math.round((pos.y + i) / scale).toString();
      width = ctx.measureText(text).width;
      posText = {
        x: adjustedSize,
        y: i,
        width: width,
        height: adjustedSize,
        text: text
      };
      ctx.save();
      ctx.translate(posText.x, posText.y);
      ctx.rotate(-Math.PI/2);
      ctx.textAlign = "center";
      ctx.fillText(posText.text, 0, 0);
      ctx.restore();
    }

    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.strokeStyle = fontColor;
    ctx.moveTo(0,rulerSize);
    ctx.lineTo(canvasWidth, rulerSize);
    ctx.stroke();

    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.moveTo(rulerSize, 0);
    ctx.lineTo(rulerSize, canvasHeight);
    ctx.stroke();

  };
  function getText(pos) {
    let text = Math.round((pos) / config.scale * config.getMeasureMultiplier());
    if(config.measureUnit === "Metric") {
      text = Math.round(text / 100) * 100;
    }

    return text.toString();
  }
};
